import { render } from "./PrintPriceLabel.vue?vue&type=template&id=1e2ae7dc&scoped=true"
import script from "./PrintPriceLabel.vue?vue&type=script&lang=js"
export * from "./PrintPriceLabel.vue?vue&type=script&lang=js"

import "./PrintPriceLabel.vue?vue&type=style&index=0&id=1e2ae7dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e2ae7dc"]])

export default __exports__